<template>
  <CIcon :name :size/>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import WarrantyStatus from '../constants/WarrantyStatus';

  const props = defineProps<{
    status: WarrantyStatus;
    size?: number;
  }>();

  const name = computed(() => {
    switch (props.status) {
      case WarrantyStatus.NO_WARRANTY:
        return 'person-euro';
      case WarrantyStatus.AWAITING:
        return 'shield-question';
      case WarrantyStatus.PARTIAL:
        return 'shield-half';
      case WarrantyStatus.WARRANTY:
        return 'shield-check';
      case WarrantyStatus.SERVICE_CONTRACT:
        return 'document-wrench';
    }
  });
</script>
